import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Suikoden II Remaster Any% Hard" mdxType="SEO" />
    <h3 {...{
      "id": "before-you-start"
    }}>{`Before You Start`}</h3>
    <p>{`Set Text Speed to Fast.`}</p>
    <p>{`Hero will be refered to as Riou.`}</p>
    <h3 {...{
      "id": "tenzan-pass"
    }}>{`Tenzan Pass`}</h3>
    <p><em parentName="p">{`"So anyway... should we go to sleep soon?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><strong parentName="p">{`4 Highland Soldier`}</strong><br parentName="p"></br>{`
`}{`Unite then auto`}</p>
    <h4 {...{
      "id": "after-first-battle"
    }}>{`After first battle`}</h4>
    <p><em parentName="p">{`"Riou, there is no other way."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`"Promise me, Riou"`}</em>{` Option 1`}</p>
    <h3 {...{
      "id": "mercenary-fort"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Blacksmith `}<strong parentName="p">{`Option 3`}</strong>{` then Flint acquired text + 1 textbox`}<br parentName="p"></br>{`
`}{`Barbara `}<strong parentName="p">{`Option 3`}</strong>{` then Boots acquired text + 1 textbox`}<br parentName="p"></br>{`
`}{`Shopkeeper Just 1 Textbox careful mashing here`}</p>
    <h3 {...{
      "id": "world-map"
    }}>{`World Map`}</h3>
    <p>{`Appear above fort`}</p>
    <h3 {...{
      "id": "ryube"
    }}>{`Ryube`}</h3>
    <p>{`Go to shop`}</p>
    <h3 {...{
      "id": "mercenary-fort-1"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Talk to Oil spills from top right except Flik's room bottom right`}</p>
    <p><strong parentName="p">{`After Jowy rescue`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Flik > "That's far enough", Jowy > "We... we're outnumbered."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Flik > Viktor > Jowy "Well that's..." > Viktor "What the hell happened?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "world-map-1"
    }}>{`World Map`}</h3>
    <p>{`Start below Mercenary Fort`}</p>
    <h3 {...{
      "id": "ryube-1"
    }}>{`Ryube`}</h3>
    <p><em parentName="p">{`Eilie > "Here we go!"`}</em>{` Knife-Throwing `}<strong parentName="p">{`Option 2 or 3`}</strong></p>
    <h4 {...{
      "id": "formation"
    }}>{`Formation`}</h4>
    <ol>
      <li parentName="ol">{`Riou > Rina`}</li>
      <li parentName="ol">{`Bolgan > Jowy`}</li>
    </ol>
    <h3 {...{
      "id": "north-sparrow-pass"
    }}>{`North Sparrow Pass`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Fire Wall`}</strong>{`, heal at Fountain`}<br parentName="p"></br>{`
`}{`Heal if needed before Mist Monster.`}<br parentName="p"></br>{`
`}{`and equip for Mist Monster`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "equipment"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "rina"
      }}>{`Rina`}</h5>
      <ul>
        <li parentName="ul">{`Optimize`}</li>
        <li parentName="ul">{`Angry Blow > Jowy's Boots (LUX)`}</li>
        <li parentName="ul">{`Remove Medicine`}</li>
        <li parentName="ul">{`Empty Slot > Riou's Gloves (LUUX)`}</li>
      </ul>
      <h5 {...{
        "id": "bolgan"
      }}>{`Bolgan`}</h5>
      <ul>
        <li parentName="ul">{`Jizo > Medicine`}</li>
      </ul>
      <h5 {...{
        "id": "eilie"
      }}>{`Eilie`}</h5>
      <ul>
        <li parentName="ul">{`Medicine > Firewall`}</li>
      </ul>
      <h5 {...{
        "id": "riou"
      }}>{`Riou`}</h5>
      <ul>
        <li parentName="ul">{`Boots > Jowy's Flaming Arrow (LUUX)`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mist-monster-960hp"
      }}>{`Mist Monster 960HP`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Rina: Circus Attack`}</li>
        <li parentName="ul">{`Riou: Attack`}</li>
        <li parentName="ul">{`Jowy: Angry Blow`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`T2 Medicines are 2 people that got hit.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Rina: Flaming Arrow`}</li>
        <li parentName="ul">{`Bolgan: Medicine`}</li>
        <li parentName="ul">{`Eilie: Fire Wall`}</li>
        <li parentName="ul">{`Riou: Medicine`}</li>
        <li parentName="ul">{`Jowy: Angry Blow`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`T3 Medicines: If it was Male form, 2 people that got hit`}<br parentName="p"></br>{`
`}{`If Female to Male, Rina and Eilie`}<br parentName="p"></br>{`
`}{`If Female Lightning Attack, Riou and Jowy.`}<br parentName="p"></br>{`
`}{`If Female Big Attack, Riou and Jowy, Bolgan Medicine Rina, Eilie Defend. This can be short with 2 really bad Circus Attack Rolls`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Rina: Flaming Arrow`}</li>
        <li parentName="ul">{`Bolgan: Attack / Medicine Rina if Female Big Attack and stayed Female`}</li>
        <li parentName="ul">{`Eilie: Attack / Defend if Female Big Attack and stayed Female`}</li>
        <li parentName="ul">{`Riou: Medicine`}</li>
        <li parentName="ul">{`Jowy: Medicine`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Rina: Circus Attack`}</li>
        <li parentName="ul">{`Riou & Jowy: Attack`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "kyaro"
    }}>{`Kyaro`}</h3>
    <h4 {...{
      "id": ""
    }}></h4>
    <ul>
      <li parentName="ul">{`Riou: Flaming Arrow`}</li>
    </ul>
    <p><em parentName="p">{`Viktor: "Damn, he ran away!", Jowy: "Wait, wait a minute."`}</em>{` `}<strong parentName="p">{`Option 2x3`}</strong></p>
    <h3 {...{
      "id": "north-sparrow-pass-1"
    }}>{`North Sparrow Pass`}</h3>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Do this menu while Viktor & Flik are still in your party`}</p>
      </blockquote>
      <h4 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "riou-1"
      }}>{`Riou`}</h5>
      <ul>
        <li parentName="ul">{`Flaming Arrows > Jowy Medicine (RDX)`}</li>
        <li parentName="ul">{`Medicine > Viktor Empty Slot (RUX)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "mercenary-fort-2"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Exit right away`}</p>
    <h3 {...{
      "id": "world-map-2"
    }}>{`World Map`}</h3>
    <p>{`Appear below Mercenary Fort, hold down then left`}</p>
    <h3 {...{
      "id": "toto"
    }}>{`Toto`}</h3>
    <p>{`Talk to the innkeeper 17 times and exit Toto `}<em parentName="p">{`talk to left side of book`}</em><br parentName="p"></br>{`
`}{`After leaving Pilika's house can hold left, won't run into girl.`}</p>
    <h3 {...{
      "id": "muse"
    }}>{`Muse`}</h3>
    <h4 {...{
      "id": "shop"
    }}>{`Shop`}</h4>
    <p><em parentName="p">{`Jowy:"What should we do?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h5 {...{
      "id": "buy"
    }}>{`Buy`}</h5>
    <p>{`Escape Talisman`}</p>
    <h3 {...{
      "id": "toto-1"
    }}>{`Toto`}</h3>
    <p><em parentName="p">{`CM: 1 Step up`}</em></p>
    <h3 {...{
      "id": "mercenary-fort-3"
    }}>{`Mercenary Fort`}</h3>
    <p><em parentName="p">{`CM: 1 Step left`}</em></p>
    <h4 {...{
      "id": "blacksmith"
    }}>{`Blacksmith`}</h4>
    <p>{`Sharpen Riou's Weapon to 3`}<br parentName="p"></br>{`
`}{`Flik gives you 2k, Apple, Jowy: "Let's go, Riou." > `}<em parentName="p">{`Walk around Flik`}</em></p>
    <h3 {...{
      "id": "ryube-2"
    }}>{`Ryube`}</h3>
    <p>{`Heal if needed`}</p>
    <h3 {...{
      "id": "ryube-forest"
    }}>{`Ryube Forest`}</h3>
    <p>{`Need to kill either a 5x Spider battle or 3x Slug battle`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-slug"
      }}>{`3 Slug`}</h4>
      <p>{`Turn 1: Riou Attack, Jowy Flaming Arrows. 1 Slug should die.`}<br parentName="p"></br>{`
`}{`Turn 2: Auto or Unite, Unite if Flaming Arrow damage 94 or less.`}</p>
      <p>{`With minimal Jowy magic growths, the T1 slug can survive (it's doomed)`}</p>
      <h4 {...{
        "id": "5-spider"
      }}>{`5 Spider`}</h4>
      <p>{`Turn 1: Riou Defend, Jowy Flaming Arrows`}<br parentName="p"></br>{`
`}{`Turn 2: Buddy Attack`}</p>
    </Battle>
    <p>{`If you killed a battle before Tsai, add him to your party. Else, add him to convoy.`}</p>
    <p>{`If Tsai in Convoy, pick up the 2 accessory chests.`}</p>
    <h4 {...{
      "id": "equipment-2"
    }}>{`Equipment`}</h4>
    <h5 {...{
      "id": "tsai-if-in-party"
    }}>{`Tsai (If in party)`}</h5>
    <ul>
      <li parentName="ul">{`Remove all armor`}</li>
    </ul>
    <h5 {...{
      "id": "riou-2"
    }}>{`Riou`}</h5>
    <p>{`Optimize`}</p>
    <p>{`After Ryube is burned down `}<em parentName="p">{`Tsai, Jowy, Tsai`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "mercenary-fort-4"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Heal Riou if he's not full HP`}</p>
    <p><em parentName="p">{`Meeting room`}</em>{` After Jowy and Pilika come inside you `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "flik-duel"
    }}>{`Flik Duel`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Flik Action`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Dialogue`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`C'mon, take a swing at me.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Don't get too confident or you'll get yourself killed.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Here goes! Hope you can handle this!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Here it comes. Better get out of the way.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Nice try. I'll go next.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Okay, it's your turn. Let's see what you've got.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Okay, let's see what you've got.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Okay, maybe I should show you what I've really got.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`One more time. Don't mess up.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Whoa, nice stroke. That's the way.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Yes, good. What'll you do next?`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`You dodged my sword, now the kid gloves are coming off...`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Better be more careful. You'll get yourself hurt.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hahaha! You're something else. Wanna try that again?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hey, be careful how you swing that thing!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hey, that was a surprise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hey, wanna try that again?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`I'm going again. Don't mess up this time.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`In combat, caution is the best weapon.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Now it's my turn. Don't faint on me.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`One of us is going to have to finish this.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Oops, I might have put too much into that one.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`That's how to attack. Try it yourself.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`That's the spirit!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The next one's going to hurt.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This is how to attack. Got it?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This is just a waste of time.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This...is how you deliver a deadly attack!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Want to try that again?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whoa. Better be careful. Someone's gonna get hurt.`}</td>
        </tr>
      </tbody>
    </table>
    <p><em parentName="p">{`Jowy: "What should we do?"`}</em>{` `}<strong parentName="p">{`Name Army`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Viktor: "Are you two ready?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "war-battle-1"
    }}>{`War Battle #1`}</h3>
    <h4 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h4>
    <p>{`1 Textbox then Select > End Turn`}</p>
    <h4 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h4>
    <p>{`Menu > End Turn`}</p>
    <h3 {...{
      "id": "war-battle-2"
    }}>{`War Battle #2`}</h3>
    <p><em parentName="p">{`Viktor, Flik, Viktor`}</em>{` `}<strong parentName="p">{`Option 2`}</strong>{` to start`}</p>
    <p>{`Move Riou 2 down if Flik doesn't block, will spawn unit & end war battle instantly.`}<br parentName="p"></br>{`
`}{`Riou has 1 Fire Spear, can maybe use to injure Flik?`}</p>
    <h3 {...{
      "id": "mercenary-fort-5"
    }}>{`Mercenary Fort`}</h3>
    <h4 {...{
      "id": "2x-4-soldier-battle"
    }}>{`2x 4 Soldier Battle`}</h4>
    <p>{`Unite until only Commander left, then auto.`}</p>
    <h3 {...{
      "id": "toto-2"
    }}>{`Toto`}</h3>
    <p><em parentName="p">{`CM: 1 Right at entrance`}</em><br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Hanna`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`CM: Want to line up right side of entrance. Need to line up manually.`}</em></p>
    <h3 {...{
      "id": "muse-1"
    }}>{`Muse`}</h3>
    <h3 {...{
      "id": "white-deer-inn"
    }}>{`White Deer Inn`}</h3>
    <p><em parentName="p">{`Alex "...Hmmm", Alex checks you out, "Okay. I'll make you an offer."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "sindar-ruins"
    }}>{`Sindar Ruins`}</h3>
    <p><em parentName="p">{`CM: Ruins entrance center`}</em></p>
    <p>{`Pick `}<strong parentName="p">{`Fire Lizard`}</strong>{`.`}</p>
    <p>{`Menu after closing Dam.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "riou-3"
      }}>{`Riou`}</h5>
      <ul>
        <li parentName="ul">{`Remove everything but Medicine`}</li>
      </ul>
      <h5 {...{
        "id": "jowy"
      }}>{`Jowy`}</h5>
      <ul>
        <li parentName="ul">{`Optimize`}</li>
        <li parentName="ul">{`Head: Nanami's Wind Feather Ornament`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "4-salamanders"
      }}>{`4 Salamanders`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Buddy Attack`}</li>
        <li parentName="ul">{`Gengen: Defend`}</li>
        <li parentName="ul">{`Nanami: Shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Shining Light`}</li>
        <li parentName="ul">{`Jowy: Defend`}</li>
        <li parentName="ul">{`Nanami: Medicine Jowy`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-and-on"
      }}>{`Turn 3 and on`}</h5>
      <ul>
        <li parentName="ul">{`Jowy Defend, Riou Medicine Jowy until only Jowy alive. Then Twinkling Blade.`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "5-megawatts"
      }}>{`5 Megawatts`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Shining Light`}</li>
        <li parentName="ul">{`Jowy: Defend`}</li>
        <li parentName="ul">{`Gengen: Attack`}</li>
        <li parentName="ul">{`Nanami: Shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-and-on"
      }}>{`Turn 2 and on`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Medicine Jowy`}</li>
        <li parentName="ul">{`Jowy: Defend`}</li>
        <li parentName="ul">{`Gengen: Attack`}</li>
        <li parentName="ul">{`Nanami: Shift`}</li>
      </ul>
      <p>{`Jowy Defend, Riou Medicine Jowy until only Jowy alive. Then Twinkling Blade.`}</p>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Chainmail`}</strong></p>
    <h4 {...{
      "id": "equipment-4"
    }}>{`Equipment`}</h4>
    <h5 {...{
      "id": "jowy-1"
    }}>{`Jowy`}</h5>
    <p>{`Optimize`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "double-head-3000hp"
      }}>{`Double Head 3000HP`}</h4>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Family Attack`}</li>
        <li parentName="ul">{`Jowy: Hungry Friend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-234"
      }}>{`Turn 2,3,4`}</h5>
      <ul>
        <li parentName="ul">{`Jowy: Piercing One`}</li>
        <li parentName="ul">{`Jowy: Piercing One`}</li>
        <li parentName="ul">{`Jowy: Flash Judgement`}</li>
      </ul>
    </Battle>
    <p><em parentName="p">{`CM: 1 Right before Treasure`}</em></p>
    <h3 {...{
      "id": "muse-2"
    }}>{`Muse`}</h3>
    <p><em parentName="p">{`CM: Entrance ~2 steps from right edge of road. Lined up on 2nd from right square tiles`}</em></p>
    <h4 {...{
      "id": "blacksmith-1"
    }}>{`Blacksmith`}</h4>
    <ul>
      <li parentName="ul">{`Embed Fire Lizard > Riou`}</li>
    </ul>
    <p>{`Viktor joins before Annabelle `}<em parentName="p">{`don't change formation`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`Jess, Jowy walks forward "What do you think?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "muse-highland-border"
    }}>{`Muse-Highland Border`}</h3>
    <p>{`Talk to right guard, then talk to him again.`}</p>
    <p>{`You want to find a rabbit fight and have Riou attack it to get him low. Under 20HP should be fine.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Can do Equipment menu anytime between picking party & entering Highland Camp`}</p>
      </blockquote>
      <h4 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "riou-4"
      }}>{`Riou`}</h5>
      <ul>
        <li parentName="ul">{`Take Jowy's Feathered Cap (LX)`}</li>
        <li parentName="ul">{`Take Jowy's Chainmail (LX)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "highland-camp"
    }}>{`Highland Camp`}</h3>
    <p><em parentName="p">{`CM: 2nd box on left going to provisions`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`CM: Right of leftmost tree at bottom`}</em></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "battle-1"
      }}>{`Battle 1`}</h4>
      <ul>
        <li parentName="ul">{`Riou Attack Jowy Defend until Riou dead, Jowy Twinkling Blade`}</li>
      </ul>
      <h4 {...{
        "id": "battle-2"
      }}>{`Battle 2`}</h4>
      <ul>
        <li parentName="ul">{`Riou: Defend:`}</li>
        <li parentName="ul">{`Nanami Medicine Riou`}</li>
        <li parentName="ul">{`If Nanami dead, T2 Shining Light.`}</li>
      </ul>
    </Battle>
    <p>{`Option 1 to run away.`}</p>
    <h3 {...{
      "id": "muse-3"
    }}>{`Muse`}</h3>
    <p>{`Go to Town Hall. `}<em parentName="p">{`CM: Bottom Wall of Annabelle's room`}</em><br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Rune Shop`}</strong></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "rune-shop"
      }}>{`Rune Shop`}</h4>
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Fire Orb`}</li>
      </ul>
      <h5 {...{
        "id": "attach"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Fire Orb > Riou's Head`}</li>
      </ul>
    </Menu>
    <p>{`Inn, then Town Hall, then Inn`}<br parentName="p"></br>{`
`}{`Exit Muse `}<em parentName="p">{`Nanami 2 textboxes`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Jowston Hill`}<br parentName="p"></br>{`
`}{`At Inn `}<em parentName="p">{`Jowy, Annabelle, Jowy`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Talk to Viktor Option 1`}</p>
    <h3 {...{
      "id": "war-battle-3"
    }}>{`War Battle #3`}</h3>
    <p>{`End Turn every turn`}<br parentName="p"></br>{`
`}{`Battle ends when you end your turn after Knights retreat`}</p>
    <h3 {...{
      "id": "muse-4"
    }}>{`Muse`}</h3>
    <p>{`Talk to Nanami `}<em parentName="p">{`1 textbox "Hey Riou..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Town Hall then Inn`}<br parentName="p"></br>{`
`}{`Inn 2nd Floor talk to Nanami `}<em parentName="p">{`1 textbox "Hey Riou..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Town Hall then Exit Muse`}</p>
    <h3 {...{
      "id": "coronet"
    }}>{`Coronet`}</h3>
    <p>{`Go to southwest dock then Inn 2nd floor then Tai Ho`}</p>
    <blockquote>
      <p parentName="blockquote">{`Keep an eye on money after Tai Ho. If somehow you have >= 13700 you can skip the Armor Shop in South Window`}</p>
    </blockquote>
    <p>{`Go to inn & get Circus crew`}</p>
    <h3 {...{
      "id": "south-window"
    }}>{`South Window`}</h3>
    <p>{`On entrance `}<em parentName="p">{`Viktor, Eilie`}</em>{` `}<strong parentName="p">{`Option 3`}</strong>{` `}<em parentName="p">{`Viktor, Pilika`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to inn. Then go to Armor Shop.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Need 13700 after selling. Can stop as soon as you have enough.`}</p>
      </blockquote>
      <h4 {...{
        "id": "armor-shop"
      }}>{`Armor Shop`}</h4>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Viktor: Half Helmet`}</li>
        <li parentName="ul">{`Viktor: Chainmail`}</li>
        <li parentName="ul">{`Riou: Chainmail`}</li>
        <li parentName="ul">{`Bag: Spark Orb`}</li>
      </ul>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Friendship Orb`}</strong>{`.`}</p>
    <p>{`Go to Town Hall.`}<br parentName="p"></br>{`
`}{`Go back to inn. Can check Eilie's magic when she joins if you missed it earlier.`}</p>
    <p>{`Head to North Window`}</p>
    <h3 {...{
      "id": "north-window"
    }}>{`North Window`}</h3>
    <p><em parentName="p">{`Nanami runs behind you, Neclord 2 textboxes.`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "cave-of-the-wind"
    }}>{`Cave of the Wind`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Blue Gate`}</strong>{` & `}<strong parentName="p">{`3000 potch`}</strong>{` `}<em parentName="p">{`Top two chests`}</em></p>
    <p><em parentName="p">{`CM: 2 Steps right before Kahn cutscene`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`Kahn, Viktor sweat animation, Kahn "So may I..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "freed"
      }}>{`Freed`}</h5>
      <ul>
        <li parentName="ul">{`Remove Wooden Shield`}</li>
        <li parentName="ul">{`Medicine > Kahn's Fire Wall (L2D)`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "star-dragon-sword-3000hp"
      }}>{`Star Dragon Sword 3000HP`}</h4>
      <p>{`Auto until you lose.`}</p>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Drops of Kindness on Riou, Kahn, Freed, Viktor`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "north-window-1"
    }}>{`North Window`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Fire Orb`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Fight assumes you get both Freed Fire Walls off. If you get less, you can auto T4 and it should be fine as long as you got other damage off.`}</p>
      </blockquote>
      <h4 {...{
        "id": "abomination-5400hp"
      }}>{`Abomination 5400HP`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Explosion`}</li>
        <li parentName="ul">{`Nanami: Defend`}</li>
        <li parentName="ul">{`Viktor: Attack`}</li>
        <li parentName="ul">{`Freed: Firewall`}</li>
        <li parentName="ul">{`Eilie: Shift`}</li>
        <li parentName="ul">{`Kahn: Exorcism`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Dancing Flames`}</li>
        <li parentName="ul">{`Viktor: Medicine Freed / Attack / Defend`}</li>
        <li parentName="ul">{`Freed: Fire Wall`}</li>
        <li parentName="ul">{`Kahn: Scolding`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Dancing Flames`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4--on"
      }}>{`Turn 4 & On`}</h5>
      <ul>
        <li parentName="ul">{`Auto, Attack does 420 damage. If more damage needed or safety needed Fire Wall for 490 damage.`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "castle"
    }}>{`Castle`}</h3>
    <p><em parentName="p">{`Viktor: "But...", Flik, Tsai, Rina: "..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Radat`}</p>
    <h3 {...{
      "id": "radat"
    }}>{`Radat`}</h3>
    <p><em parentName="p">{`OM: Enter town from the bottom. Use tree below Radat to line up horizontally`}</em><br parentName="p"></br>{`
`}{`Tavern after Shu leaves Apple `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Richmond `}<strong parentName="p">{`Option 2`}</strong>{` then Option 1`}</p>
    <p><em parentName="p">{`CM: Bridge screen 1 up`}</em></p>
    <p>{`Sluice Gate `}<strong parentName="p">{`Option 2 x3`}</strong></p>
    <h4 {...{
      "id": "amada-duel-1"
    }}>{`Amada Duel #1`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Amada Action`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Dialogue`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Argh! I'll get ya next time!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`ARGH!!!  Nice shot... But it ain't over yet!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Dammit! I might lose this one!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Damn! Dammit! Gotta think!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Hehe, first show me what you've got, boy.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`I won't fall for that one again!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Okay, boy, here I go!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Okay, first a little test...`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Okay, it's my turn next!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Ouch! I definitely felt that one!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Way to go, kid! But I won't lose that easy!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Better get ready. Here I go again!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`C'mon. It's your turn now.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Got to keep your head cool when you're in a fight, y'know.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Haha! Wanna try that again?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hahahaha! Too bad, boy! Now it's my turn!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hehe, doesn't work so well the second time, eh?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hehe, I guess I'd better hold back a little.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hehe, I'll show ya how to attack!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hey, you're not gonna win that way, y'know.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I'm just about ready to take the kid gloves off.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If ya liked that, I'll give ya some more.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch! I felt that one!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch! Pretty good!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch! That musta hurt! Sorry about that.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`That was fun! Let's go again!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`That won't get us anywhere! Try this one on fer size!!!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thinking the same thing, eh. C'mon let's go.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whoa! That was scary!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`YOWCH!!!  Nice one! My hand's all numb!`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "castle-1"
    }}>{`Castle`}</h3>
    <p><strong parentName="p">{`Option 2`}</strong>{` to lead battle`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "war-battle-4"
    }}>{`War Battle #4`}</h3>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Riou move left, Repair Self / Bright Shield`}</li>
      <li parentName="ul">{`State Soldier move left if strat fails`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`You get ~1:40 break here unless a unit with with death dialogue dies`}</em></p>
    </blockquote>
    <h5 {...{
      "id": "turn-2--on"
    }}>{`Turn 2 & on`}</h5>
    <ul>
      <li parentName="ul">{`Move State Soldier out of Solon Jhee's range`}</li>
    </ul>
    <h3 {...{
      "id": "castle-2"
    }}>{`Castle`}</h3>
    <p>{`Go to Bed, Nanami, `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Great Hall`}<br parentName="p"></br>{`
`}{`Name Castle after Eilie talks`}</p>
    <p><em parentName="p">{`Go to Castle entrance`}</em>{` Fitcher `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Great Hall `}<em parentName="p">{`Flik, Fitcher, Flik`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Tavern, talk to Leona.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Eilie (X)`}</li>
        <li parentName="ul">{`Luc (RUX)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Nanami > Eilie`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Luc Mega Medicine > Sacrifical Jizo`}</li>
      </ul>
    </Menu>
    <p>{`Go to Radat`}</p>
    <h3 {...{
      "id": "radat-1"
    }}>{`Radat`}</h3>
    <p><em parentName="p">{`OM: Enter town from the bottom. Use tree below Radat to line up horizontally`}</em><br parentName="p"></br>{`
`}{`Talk to Amada Option 1 x2`}</p>
    <h4 {...{
      "id": "amada-duel-2"
    }}>{`Amada Duel #2`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Amada Action`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Dialogue`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Argh! I'll get ya next time!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`ARGH!!!  Nice shot... But it ain't over yet!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Dammit! I might lose this one!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Damn! Dammit! Gotta think!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Hehe, first show me what you've got, boy.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`I won't fall for that one again!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Okay, boy, here I go!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Okay, first a little test...`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Okay, it's my turn next!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Ouch! I definitely felt that one!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Way to go, kid! But I won't lose that easy!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Better get ready. Here I go again!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`C'mon. It's your turn now.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Got to keep your head cool when you're in a fight, y'know.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Haha! Wanna try that again?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hahahaha! Too bad, boy! Now it's my turn!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hehe, doesn't work so well the second time, eh?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hehe, I guess I'd better hold back a little.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hehe, I'll show ya how to attack!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hey, you're not gonna win that way, y'know.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I'm just about ready to take the kid gloves off.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If ya liked that, I'll give ya some more.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch! I felt that one!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch! Pretty good!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch! That musta hurt! Sorry about that.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`That was fun! Let's go again!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`That won't get us anywhere! Try this one on fer size!!!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thinking the same thing, eh. C'mon let's go.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whoa! That was scary!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`YOWCH!!!  Nice one! My hand's all numb!`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Go to `}<strong parentName="p">{`South Window`}</strong>{`.`}</p>
    <h3 {...{
      "id": "south-window-1"
    }}>{`South Window`}</h3>
    <p>{`Go to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`4 Lightning Crystal`}</li>
      </ul>
      <h5 {...{
        "id": "attach-1"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Lightning > Riou LH`}</li>
        <li parentName="ul">{`Lightning > Eilie RH`}</li>
        <li parentName="ul">{`Lightning > Luc LH`}</li>
        <li parentName="ul">{`Blue Gate > Luc Head`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "castle-3"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall`}</p>
    <h3 {...{
      "id": "two-river"
    }}>{`Two River`}</h3>
    <blockquote>
      <p parentName="blockquote">{`After Chaco steals wallet go to winger section. Don't need to go to City Hall.`}</p>
    </blockquote>
    <p>{`First Chaco chase, chase him x2 go around Chase him x3 go around and finish Chase. Saves ~2s.`}</p>
    <p>{`If you didn't recruit Gilbert, recruits `}<strong parentName="p">{`Hans`}</strong>{`.`}</p>
    <p>{`Ridley and Makai fighting `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Makai asks for help `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "sewer"
    }}>{`Sewer`}</h3>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`You want only Riou and optionally Luc to survive this.`}<br parentName="p"></br>{`
`}{`If Eilie doesn't have / doesn't get off her Bolt, this becomes a 4T fight with Luc using his BoW scroll.`}<br parentName="p"></br>{`
`}{`In that case, if Freed gets his Fire Wall off you can Blazing Camp.`}</p>
      </blockquote>
      <h4 {...{
        "id": "pest-rat-6240hp"
      }}>{`Pest Rat 6240HP`}</h4>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Lightning Ball`}</li>
        <li parentName="ul">{`Eilie: Bolt of Wrath / Attack`}</li>
        <li parentName="ul">{`Nanami: Defend`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Bolt of Wrath`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Can replace Riou attack with Luc Empty World if you need to heal. AVG Magic is 3 damage short without Eilie ATK`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Bolt of Wrath`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath Scroll`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Attack`}</li>
        <li parentName="ul">{`Luc: Thor Shot / Empty World`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If Luc kept his Jizo, you will need to unequip it before 2nd Greenhill fight at the latest.`}</p>
      </blockquote>
    </Battle>
    <h3 {...{
      "id": "two-river-1"
    }}>{`Two River`}</h3>
    <p>{`Reinforcements `}<strong parentName="p">{`Option 2`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "soldier-fight-1"
      }}>{`Soldier Fight 1`}</h4>
      <ul>
        <li parentName="ul">{`Shining Light`}</li>
      </ul>
      <p><strong parentName="p">{`After Battle Option 2`}</strong>{` then Option 1, `}<strong parentName="p">{`Option 2`}</strong></p>
      <h4 {...{
        "id": "soldier-fight-2"
      }}>{`Soldier Fight 2`}</h4>
      <ul>
        <li parentName="ul">{`Luc Empty World`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "lakewest--castle"
    }}>{`Lakewest > Castle`}</h3>
    <h4 {...{
      "id": "party-1"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Luc (2U)`}</li>
    </ul>
    <h3 {...{
      "id": "lakewest--world-map--greenhill"
    }}>{`Lakewest > World Map > Greenhill`}</h3>
    <p>{`Pick names after Fitcher leaves & Flik talks`}<br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong></p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Goal for this fight is to end with only Riou and/or Luc alive.`}</p>
      </blockquote>
      <h4 {...{
        "id": "5-soldiers"
      }}>{`5 Soldiers`}</h4>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Attack 1`}</li>
        <li parentName="ul">{`Luc: Attack 2`}</li>
        <li parentName="ul">{`Nanami: Attack 3`}</li>
        <li parentName="ul">{`Flik: Shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2--on-1"
      }}>{`Turn 2 & On`}</h5>
      <ul>
        <li parentName="ul">{`Once Flik has gotten hit at least once, Luc Empty World`}</li>
      </ul>
    </Battle>
    <p>{`Do this menu before the next fight!`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If he still has it, remove Luc's Jizo`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Luc > Flik`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Goal for this fight is to end with only Flik alive`}</p>
      </blockquote>
      <h4 {...{
        "id": "5-soldiers-1"
      }}>{`5 Soldiers`}</h4>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Attack 2`}</li>
        <li parentName="ul">{`Flik: Mega Medicine Self`}</li>
        <li parentName="ul">{`Nanami: Attack 1`}</li>
        <li parentName="ul">{`Luc: Shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2--on-2"
      }}>{`Turn 2 & On`}</h5>
      <ul>
        <li parentName="ul">{`Keep Flik healthy, get Riou low via Fire Lizard and kill everyone else.`}</li>
        <li parentName="ul">{`Once Riou is low enough, finish with Riou Attack and Flik Thunder Runner`}</li>
        <li parentName="ul">{`You can also use Angry Blow/Thunder Runner to clear enemies earlier if everyone is already low.`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "rune-shop-1"
      }}>{`Rune Shop`}</h4>
      <h5 {...{
        "id": "attach-2"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Fire > Luc Head`}</li>
        <li parentName="ul">{`Blue Gate > Riou Head`}</li>
        <li parentName="ul">{`Fire > Flik LH`}</li>
      </ul>
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Resurrection Orb`}</li>
      </ul>
      <h4 {...{
        "id": "blacksmith-2"
      }}>{`Blacksmith`}</h4>
      <h5 {...{
        "id": "sharpen"
      }}>{`Sharpen`}</h5>
      <ul>
        <li parentName="ul">{`Riou: 7`}</li>
      </ul>
      <h5 {...{
        "id": "embed"
      }}>{`Embed`}</h5>
      <ul>
        <li parentName="ul">{`Friendship > Riou`}</li>
      </ul>
    </Menu>
    <p>{`For soldier fights:`}</p>
    <ul>
      <li parentName="ul">{`4: Auto`}</li>
      <li parentName="ul">{`5: Shining Light`}</li>
    </ul>
    <h3 {...{
      "id": "lakewest"
    }}>{`Lakewest`}</h3>
    <p>{`Optionally pick up `}<strong parentName="p">{`Kindness Orb`}</strong>{` to sell for $11000`}</p>
    <h3 {...{
      "id": "castle-4"
    }}>{`Castle`}</h3>
    <p>{`Go back to bed`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "party-2"
      }}>{`Party`}</h4>
      <ul>
        <li parentName="ul">{`Rina (U)`}</li>
        <li parentName="ul">{`Nanami (3D)`}</li>
      </ul>
      <h4 {...{
        "id": "formation-3"
      }}>{`Formation`}</h4>
      <ul>
        <li parentName="ul">{`Riou > Rina (Just for faster menuing)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "lakewest-1"
    }}>{`Lakewest`}</h3>
    <p>{`Go to Item Shop`}</p>
    <Menu mdxType="Menu">
      <p>{`Want at least $36000. Sell stuff as needed. Minimum money you'll have is ~$25000.`}</p>
      <h4 {...{
        "id": "buy-4"
      }}>{`Buy`}</h4>
      <ul>
        <li parentName="ul">{`2 Escape Talisman`}</li>
        <li parentName="ul">{`4+ Jizos, Equip 1 to Rina`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "greenhill-matilda-border"
    }}>{`Greenhill-Matilda Border`}</h3>
    <p>{`Viki Option 1 `}<strong parentName="p">{`_then Option 2`}</strong>{`_`}</p>
    <h3 {...{
      "id": "rockaxe"
    }}>{`Rockaxe`}</h3>
    <p><em parentName="p">{`CM: 1 step right entering door before refugees`}</em><br parentName="p"></br>{`
`}{`Camus refugee battle `}<strong parentName="p">{`_Option 3`}</strong>{`_`}</p>
    <h3 {...{
      "id": "muse-matilda-border"
    }}>{`Muse-Matilda Border`}</h3>
    <p>{`Miklotov `}<strong parentName="p">{`Option 2`}</strong>{`, to `}<strong parentName="p">{`Convoy`}</strong></p>
    <h3 {...{
      "id": "muse-5"
    }}>{`Muse`}</h3>
    <p>{`Miklotov 2 textboxes then ~50 second cutscene break.`}</p>
    <h4 {...{
      "id": "soldier-fight"
    }}>{`Soldier fight`}</h4>
    <p>{`Riou Empty World`}</p>
    <h3 {...{
      "id": "muse-matilda-border-1"
    }}>{`Muse-Matilda Border`}</h3>
    <p><em parentName="p">{`CM: 1 tile right on entrance`}</em></p>
    <h3 {...{
      "id": "rockaxe-1"
    }}>{`Rockaxe`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "rune-shop-2"
      }}>{`Rune Shop`}</h4>
      <h5 {...{
        "id": "attach-3"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Lightning > Rina LH`}</li>
        <li parentName="ul">{`Resurrection > Riou Head`}</li>
        <li parentName="ul">{`Resurrection > Nanami RH`}</li>
        <li parentName="ul">{`Blue Gate > Rina Head`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "castle-5"
    }}>{`Castle`}</h3>
    <p>{`Great Hall > Go to bed > Great Hall`}<br parentName="p"></br>{`
`}{`Talk to Apple to change army formation`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`The units in random slots will be referred to as `}<strong parentName="p">{`Other`}</strong><br parentName="p"></br>{`
`}{`If the leader of a unit is random, leader will be refered to as `}<em parentName="p">{`Unknown`}</em><br parentName="p"></br>{`
`}{`Knight = Miklotov or Camus`}</p>
      </blockquote>
      <h4 {...{
        "id": "army-formation"
      }}>{`Army Formation`}</h4>
      <p>{`This menu assumes Gilbert recruited.`}</p>
      <h5 {...{
        "id": "alternate-kiba"
      }}>{`Alternate Kiba`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Default`}</strong></li>
        <li parentName="ul">{`Riou `}<strong parentName="li">{`Shu`}</strong>{` > Ridley `}<strong parentName="li">{`Chaco`}</strong></li>
        <li parentName="ul">{`Gilbert `}<strong parentName="li">{`Knight`}</strong>{` > Viktor `}<strong parentName="li">{`Other`}</strong></li>
        <li parentName="ul">{`Viktor `}<strong parentName="li">{`Camus`}</strong>{` > `}<em parentName="li">{`Unknown`}</em>{` `}<strong parentName="li">{`Adlai`}</strong></li>
        <li parentName="ul"><em parentName="li">{`Unknown`}</em>{` `}<strong parentName="li">{`Camus`}</strong>{` > Riou `}<strong parentName="li">{`Nanami`}</strong></li>
      </ul>
      <h5 {...{
        "id": "kill-kiba"
      }}>{`Kill Kiba`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Default`}</strong></li>
        <li parentName="ul">{`Flik `}<strong parentName="li">{`Other`}</strong>{` > Ridley `}<strong parentName="li">{`Chaco`}</strong></li>
        <li parentName="ul">{`Gilbert `}<strong parentName="li">{`Knight`}</strong>{` > Luc `}<strong parentName="li">{`Other`}</strong></li>
        <li parentName="ul"><em parentName="li">{`Unknown`}</em>{` `}<strong parentName="li">{`Adlai`}</strong>{` > Viktor `}<strong parentName="li">{`Other`}</strong></li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "army-formation-1"
    }}>{`Army Formation`}</h4>
    <p>{`Teleport to Radat (2D)`}</p>
    <h3 {...{
      "id": "radat-2"
    }}>{`Radat`}</h3>
    <p>{`Option 1`}<br parentName="p"></br>{`
`}{`Re-enter Radat, `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "castle-6"
    }}>{`Castle`}</h3>
    <p><strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "war-battle"
    }}>{`War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <p>{`Riou 1U`}<br parentName="p"></br>{`
`}{`Top Kobold 1U`}<br parentName="p"></br>{`
`}{`Flik 2L`}<br parentName="p"></br>{`
`}{`Viktor 2L`}<br parentName="p"></br>{`
`}{`Mid Kobold 1U`}<br parentName="p"></br>{`
`}{`Luc 2L`}<br parentName="p"></br>{`
`}{`Gilbert 1L`}<br parentName="p"></br>{`
`}{`Teresa 1L`}</p>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <p>{`Riou 1U`}<br parentName="p"></br>{`
`}{`Flik 2U`}<br parentName="p"></br>{`
`}{`Viktor 2L`}<br parentName="p"></br>{`
`}{`Teresa 1L`}<br parentName="p"></br>{`
`}{`Gilbert 1L`}</p>
    <h5 {...{
      "id": "turn-3--4"
    }}>{`Turn 3 & 4`}</h5>
    <p>{`Move anyone who might get attacked.`}<br parentName="p"></br>{`
`}{`Luc 1U`}<br parentName="p"></br>{`
`}{`Teresa 1L`}</p>
    <h3 {...{
      "id": "castle-7"
    }}>{`Castle`}</h3>
    <p>{`Go to bed.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "kiba-war-battle"
    }}>{`Kiba War Battle`}</h3>
    <h4 {...{
      "id": "standard-strat"
    }}>{`Standard Strat`}</h4>
    <h5 {...{
      "id": "turns-1-5"
    }}>{`Turns 1-5`}</h5>
    <p>{`Move 3R1U`}</p>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <p>{`Luc Wind Magic`}<br parentName="p"></br>{`
`}{`Flik Fire Spear (If Luc failed)`}<br parentName="p"></br>{`
`}{`Gilbert DR`}</p>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <p>{`Riou`}<br parentName="p"></br>{`
`}{`Gilbert 2R`}<br parentName="p"></br>{`
`}{`Luc Wind Magic (If Kiba < 2 damage)`}<br parentName="p"></br>{`
`}{`Flik Fire Spear (If Kiba < 2 damage)`}</p>
    <h5 {...{
      "id": "turn-8--on"
    }}>{`Turn 8 & on`}</h5>
    <p>{`Use Judgement`}</p>
    <h4 {...{
      "id": "alternate-strat"
    }}>{`Alternate Strat`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Can use `}<a parentName="p" {...{
          "href": "https://www.youtube.com/watch?v=_1a6RA_gIds"
        }}>{`this video`}</a>{` as a reference.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`So this strat revolves around pulling Kiba's army away from your main army's position. With Chaco & Camus, we have enough defense that Rowd's army will never attack Riou & Kiba's army will tend to not attack you in melee range.`}<br parentName="p"></br>{`
`}{`First 3 turns are always the same, afterwards you might have to adjust Riou's movement based on enemy unit positions.`}<br parentName="p"></br>{`
`}{`Turn 4 you probably want to move as far right as possible without getting in range of an enemy unit.`}<br parentName="p"></br>{`
`}{`Turn 5 you'll probably need to move left & down to pull the soldiers furthest to the top left towards you instead of Viktor.`}<br parentName="p"></br>{`
`}{`Turn 6 you want to move Viktor, Flik, Teresa away & move Riou towards the top right side. Make sure that the soldier's to the left are closer to Riou than they are to Viktor.`}<br parentName="p"></br>{`
`}{`Turn 7 move Riou towards the top right, preferably into a chokepoint that minimizes attacks. Move Viktor, Flik, Teresa away a bit more.`}<br parentName="p"></br>{`
`}{`Turn 8 & on just move Kobolds away and minimize attacks on Riou.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`This strat by my estimate is approximately 1 minute slower than killing Kiba. There is variance, it depends on how many attacks there are during the battle. If you're going for WR standard Kiba makes more sense. If you're trying to improve, PB, or just practice I think this strat is better because of how much more consistent it is.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <p>{`Riou 2R1D`}</p>
    <h5 {...{
      "id": "turn-23"
    }}>{`Turn 2&3`}</h5>
    <p>{`Riou 2R`}</p>
    <h5 {...{
      "id": "turn-4on"
    }}>{`Turn 4&on`}</h5>
    <p>{`Use Riou to pull Kiba's army to the right, move rest of army away from Kiba's army.`}</p>
    <p>{`Kiba Option 1 then `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "castle-8"
    }}>{`Castle`}</h3>
    <p>{`Trigger Sheena, then `}<strong parentName="p">{`Exit and Re-enter Castle`}</strong>{`. `}</p>
    <blockquote>
      <p parentName="blockquote">{`Using Viki to teleport to Castle saves .2s but can fail teleport.`}</p>
    </blockquote>
    <p>{`Sheena form an alliance `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-3"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Flik (X)`}</li>
        <li parentName="ul">{`Rina (U)`}</li>
        <li parentName="ul">{`Luc (LDX)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Rina > Luc`}</li>
      </ul>
    </Menu>
    <p>{`Teleport to Radat (5D)`}</p>
    <h3 {...{
      "id": "radat-3"
    }}>{`Radat`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Stallion`}</strong>{`.`}</p>
    <h3 {...{
      "id": "banner-village--banner-pass"
    }}>{`Banner Village > Banner Pass`}</h3>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Set battle speed to 3x`}</p>
      </blockquote>
      <h4 {...{
        "id": "worm-5240hp"
      }}>{`Worm 5240HP`}</h4>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Bolt of Wrath`}</li>
        <li parentName="ul">{`Freed: Defend`}</li>
        <li parentName="ul">{`Flik: Blazing Camp`}</li>
        <li parentName="ul">{`Rina: Blazing Camp`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath`}</li>
      </ul>
    </Battle>
    <p>{`On final screen (screen after screen after Worm) `}<strong parentName="p">{`Escape Talisman`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`CM: After Escape Talisman hold up-right`}</em></p>
    <h3 {...{
      "id": "gregminster"
    }}>{`Gregminster`}</h3>
    <p><strong parentName="p">{`When Sheena asks which girl Option 2 to get Kasumi`}</strong><br parentName="p"></br>{`
`}{`Add `}<strong parentName="p">{`Kasumi`}</strong>{` to party.`}</p>
    <p>{`Do this menu before exiting the forest.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "equipment-8"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "kasumi"
      }}>{`Kasumi`}</h5>
      <ul>
        <li parentName="ul">{`Ninja Suit > Rina (LU)`}</li>
        <li parentName="ul">{`Bolt of Wrath > Luc (2LU)`}</li>
        <li parentName="ul">{`Speed Ring > Flik Leather Cape (2LD)`}</li>
        <li parentName="ul">{`Winged Boots > Rina (LD)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "castle-9"
    }}>{`Castle`}</h3>
    <p>{`Exit & Blinking Mirror.`}<br parentName="p"></br>{`
`}{`Meeting Room > Talk to Nanami`}</p>
    <p><strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "ridley-capture-war-battle"
    }}>{`Ridley Capture War Battle`}</h3>
    <h4 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h4>
    <ul>
      <li parentName="ul">{`End Turn`}</li>
    </ul>
    <h4 {...{
      "id": "turn-2--on-3"
    }}>{`Turn 2 & on`}</h4>
    <p>{`Flik Fire Spear Riou `}<em parentName="p">{`Flik is to the right of Riou`}</em><br parentName="p"></br>{`
`}{`Viktor Invention Riou`}</p>
    <h3 {...{
      "id": "army-formation-2"
    }}>{`Army Formation`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Viktor`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Flik`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Kasumi`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Shu`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tsai`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Miklotov`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Klaus`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Chaco`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Adlai`}</strong></td>
        </tr>
      </tbody>
    </table>
    <p>{`Go to bed Tsai `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "luca-war-battle"
    }}>{`Luca War Battle`}</h3>
    <h4 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h4>
    <p>{`Flik Fire Spear Luca`}<br parentName="p"></br>{`
`}{`Kasumi Invention Luca`}</p>
    <h4 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h4>
    <p>{`Flik Fire Spear Luca`}</p>
    <h3 {...{
      "id": "castle-10"
    }}>{`Castle`}</h3>
    <p>{`1st Floor to trigger scene (Run close to Luc before going down to save ~1s)`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to kick Luca's ass`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "riou-5"
      }}>{`Riou`}</h4>
      <h5 {...{
        "id": "party-4"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Rina (U)`}</li>
        <li parentName="ul">{`Tuta (R)`}</li>
        <li parentName="ul">{`Luc (RD)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If having issues with Eilie surviving, can bring Viki instead of Gengen`}</p>
      </blockquote>
      <h4 {...{
        "id": "flik"
      }}>{`Flik`}</h4>
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Eilie (2U)`}</li>
        <li parentName="ul">{`Viki (3D)`}</li>
        <li parentName="ul">{`Miklotov (RD)`}</li>
        <li parentName="ul">{`Camus (D)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Eilie > Gengen`}</li>
        <li parentName="ul">{`Eilie > Miklotov`}</li>
        <li parentName="ul">{`Eilie > Camus`}</li>
        <li parentName="ul">{`Eilie > Slot 6`}</li>
      </ul>
      <h5 {...{
        "id": "viktor"
      }}>{`Viktor`}</h5>
      <p>{`Skip`}</p>
    </Menu>
    <p>{`After party selection `}<em parentName="p">{`Shu talks`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Need 1 physical hit / counter between Flik & Riou phases. ~36 damage.`}</p>
      </blockquote>
      <h4 {...{
        "id": "luca-flik-party"
      }}>{`Luca Flik Party`}</h4>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Flik: Lightning Ball Luca`}</li>
        <li parentName="ul">{`Miklotov: Attack`}</li>
        <li parentName="ul">{`Camus: Explosion`}</li>
        <li parentName="ul">{`Eilie: Bolt of Wrath Luca`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Flik: Bolt of Wrath`}</li>
        <li parentName="ul">{`Camus: Dancing Flames`}</li>
        <li parentName="ul">{`Eilie: Shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Flik: Bolt of Wrath`}</li>
        <li parentName="ul">{`Camus: Dancing Flames`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-2"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Flik: Lightning Ball`}</li>
      </ul>
    </Battle>
    <h4 {...{
      "id": "luca-viktor"
    }}>{`Luca Viktor`}</h4>
    <p>{`Auto`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "luca-riou"
      }}>{`Luca Riou`}</h4>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Lightning Ball`}</li>
        <li parentName="ul">{`Rina: Lightning Ball`}</li>
        <li parentName="ul">{`Luc: Lightning Ball`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Riou can heal one of these turns if needed and there is at least 1 physical hit somewhere.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Bolt of Wrath`}</li>
        <li parentName="ul">{`Rina: Lightning Ball`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Bolt of Wrath`}</li>
        <li parentName="ul">{`Rina: Pale Palace / Bolt of Wrath`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-3"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Attack / Defend`}</li>
        <li parentName="ul">{`Rina: Pale Palace / Bolt of Wrath`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath (Scroll)`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "2-whitewolves-battles"
      }}>{`2 Whitewolves Battles`}</h4>
      <h5 {...{
        "id": "battle-1-1"
      }}>{`Battle 1`}</h5>
      <ul>
        <li parentName="ul">{`Rina Pale Palace`}</li>
        <li parentName="ul">{`Flik Mega Medicine Riou if needed for Duel`}</li>
      </ul>
      <h5 {...{
        "id": "battle-2-1"
      }}>{`Battle 2`}</h5>
      <ul>
        <li parentName="ul">{`Flik Dancing Flames`}</li>
      </ul>
    </Battle>
    <h4 {...{
      "id": "luca-duel-135hp"
    }}>{`Luca Duel 135HP`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Luca Action`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Dialogue`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Filth! You dare to wound me!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Filthy pig! Eat this!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Fool! That can't stop me!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Ridiculous! You think a brat like you can stop me?!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`That's nothing!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`You impertinent little pig!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`You little brat!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`You little brat...`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`BWAHAHAHA!!! Die! Die!!! DIE!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`BWAHAHAHAHAHAHA!!!!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`BWHAHAHAHAHA!!!  Oh yes! I'll disgrace your head under the sun!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Damned insect! Eat this!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Feel my strength!!! Feel my sword!!!!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Fool! Is that the best you can do!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hah... Hahaha... Fighting is my life...!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hah... No...not yet!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hah... This time...`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`HAHAHAHAHAHAHAH!!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`I love it! I love it! `}{`[HERO]`}{`!!!  BWAHAHAHAHAHAHA!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`I won't be defeated by a mere blade!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`I won't let an insect like you get in my way!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Impertinent brat!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pathetic! Is that all you've got?!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pathetic! You really thought you could defeat me!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`That's right! Battle!!! I just love a good fight!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You can't take it forever! A pathetic insect like you!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You fool!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You little brat! I'll kill you!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You pig! You! Dirty! Filthy! PIIIG!!!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You're nothing! Nothing, you hear me! NOTHING!!!`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "castle-11"
    }}>{`Castle`}</h3>
    <p>{`Go to 1st floor, run close to Luc before going down to save 1s`}<br parentName="p"></br>{`
`}{`Teleport to Kuskus (3D)`}</p>
    <h3 {...{
      "id": "kuskus"
    }}>{`Kuskus`}</h3>
    <p>{`After Culgan leave by boat and Blinking Mirror`}</p>
    <h3 {...{
      "id": "castle-12"
    }}>{`Castle`}</h3>
    <p><em parentName="p">{`Teresa talks`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "party-6"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Stallion (L2U)`}</li>
    </ul>
    <h3 {...{
      "id": "muse-6"
    }}>{`Muse`}</h3>
    <p>{`After archers Jowy `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Viktor > `}<strong parentName="p">{`Convoy`}</strong></p>
    <h5 {...{
      "id": "6-soldiers"
    }}>{`6 Soldiers`}</h5>
    <ul>
      <li parentName="ul">{`Riou Pale Palace`}</li>
    </ul>
    <p><em parentName="p">{`CM: Line up center of town on exit`}</em></p>
    <h3 {...{
      "id": "castle-13"
    }}>{`Castle`}</h3>
    <p>{`Leave Castle then Blinking Mirror`}<br parentName="p"></br>{`
`}{`Trigger Shu cutscene`}<br parentName="p"></br>{`
`}{`Teleport to Castle (1R1U)`}</p>
    <p>{`Run left to wall then up to trigger Koyu, `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Viktor `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Koyu > Party`}<br parentName="p"></br>{`
`}{`Nanami `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Teleport to Two River (3U)`}</p>
    <h3 {...{
      "id": "two-river--drakemouth"
    }}>{`Two River > Drakemouth`}</h3>
    <p>{`Gijimu Cutscene then run to Tigermouth`}</p>
    <h3 {...{
      "id": "tigermouth--tinto"
    }}>{`Tigermouth > Tinto`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Power Ring`}</strong><br parentName="p"></br>{`
`}{`All dialogue options Option 1`}</p>
    <p>{`After the second time going to bed go to Nanami's room instead of your room.`}</p>
    <h4 {...{
      "id": "neclord-fight"
    }}>{`Neclord Fight`}</h4>
    <p>{`Auto`}</p>
    <p>{`After Cutscene `}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "items-1"
      }}>{`Items`}</h4>
      <ul>
        <li parentName="ul">{`Mega Medicine Riou & Nanami`}</li>
        <li parentName="ul">{`Escape Talisman`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "crom"
    }}>{`Crom`}</h3>
    <h4 {...{
      "id": "party-7"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Rina (2U)`}</li>
      <li parentName="ul">{`Sheena (D)`}</li>
      <li parentName="ul">{`Luc (L)`}</li>
    </ul>
    <h4 {...{
      "id": "formation-6"
    }}>{`Formation`}</h4>
    <ul>
      <li parentName="ul">{`Viktor > Sheena`}</li>
    </ul>
    <p>{`Kahn scene put `}<strong parentName="p">{`Kahn in convoy`}</strong>{`. Exit Crom.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "equipment-9"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "luc"
      }}>{`Luc`}</h5>
      <ul>
        <li parentName="ul">{`Bolt of Wrath > Viktor Medicine`}</li>
        <li parentName="ul">{`Medicine > Sacrifical Jizo`}</li>
      </ul>
      <h4 {...{
        "id": "items-2"
      }}>{`Items`}</h4>
      <ul>
        <li parentName="ul">{`Blinking Mirror`}</li>
      </ul>
    </Menu>
    <p>{`Teleport to Tigermouth `}<strong parentName="p">{`1R2U`}</strong></p>
    <h3 {...{
      "id": "tigermouth"
    }}>{`Tigermouth`}</h3>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`This kill is very tight, with bad magic might need the Sheena attack`}</p>
      </blockquote>
      <h4 {...{
        "id": "sierra-3360hp"
      }}>{`Sierra 3360HP`}</h4>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Exorcism`}</li>
        <li parentName="ul">{`Nanami: Exorcism`}</li>
        <li parentName="ul">{`Sheena: Attack`}</li>
        <li parentName="ul">{`Rina: Empty World`}</li>
        <li parentName="ul">{`Viktor: Defend`}</li>
        <li parentName="ul">{`Luc: Shredding`}</li>
      </ul>
    </Battle>
    <p>{`Sierra to Convoy`}<br parentName="p"></br>{`
`}{`Teleport to Crom `}<strong parentName="p">{`1R3D`}</strong></p>
    <h3 {...{
      "id": "crom-1"
    }}>{`Crom`}</h3>
    <p><strong parentName="p">{`Stay at the Inn.`}</strong></p>
    <h4 {...{
      "id": "party-8"
    }}>{`Party`}</h4>
    <p>{`Nanami > Convoy`}<br parentName="p"></br>{`
`}{`Kahn > Party`}<br parentName="p"></br>{`
`}{`Sierra > Convoy`}</p>
    <p>{`Leave Crom through top left path`}</p>
    <h3 {...{
      "id": "tinto-mines"
    }}>{`Tinto Mines`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Master Garb`}</strong></p>
    <p>{`Before Golem heal if important people can die.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "golem-9000hp"
      }}>{`Golem 9000HP`}</h4>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Lightning Ball`}</li>
        <li parentName="ul">{`Sheena: Defend`}</li>
        <li parentName="ul">{`Luc: Lightning Ball`}</li>
        <li parentName="ul">{`Rina: Blazing Camp`}</li>
        <li parentName="ul">{`Viktor: Bolt of Wrath Scroll`}</li>
        <li parentName="ul">{`Kahn: Medicine Self`}</li>
      </ul>
    </Battle>
    <p>{`Continue through the mines.`}</p>
    <h3 {...{
      "id": "tinto"
    }}>{`Tinto`}</h3>
    <p>{`Kill Zombies with `}<strong parentName="p">{`Shining Light`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "neclord-5400hp"
      }}>{`Neclord 5400HP`}</h4>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Exorcism`}</li>
        <li parentName="ul">{`Sheena: Defend`}</li>
        <li parentName="ul">{`Luc: Lightning Ball / Bolt of Wrath`}</li>
        <li parentName="ul">{`Rina: Pale Palace`}</li>
        <li parentName="ul">{`Viktor: Defend`}</li>
        <li parentName="ul">{`Kahn: Exorcism`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Exorcism`}</li>
        <li parentName="ul">{`Luc: Bolt of Wrath`}</li>
        <li parentName="ul">{`Rina: Defend / Pale Palace`}</li>
      </ul>
    </Battle>
    <h4 {...{
      "id": "blacksmith-3"
    }}>{`Blacksmith`}</h4>
    <h5 {...{
      "id": "sharpen-1"
    }}>{`Sharpen`}</h5>
    <p>{`Riou > L12/13 (13 if bad STR)`}</p>
    <p>{`Jess Option 1 `}<strong parentName="p">{`then Option 2 (I won't fight together.)`}</strong><br parentName="p"></br>{`
`}{`Teleport to Castle.`}</p>
    <h3 {...{
      "id": "castle-14"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall.`}<br parentName="p"></br>{`
`}{`Go to bed (3rd floor).`}<br parentName="p"></br>{`
`}{`Take the elevator to the `}<strong parentName="p">{`1st floor`}</strong>{` & go to stairs to trigger the cutscene with Chaco.`}<br parentName="p"></br>{`
`}{`Go back to the `}<strong parentName="p">{`1st floor`}</strong>{`, take elevator to 3rd floor. Go back to bed.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lucia-1800hp"
      }}>{`Lucia 1800HP`}</h4>
      <ul>
        <li parentName="ul">{`Lightning Ball`}</li>
        <li parentName="ul">{`Bolt of Wrath`}</li>
        <li parentName="ul">{`Auto`}</li>
      </ul>
    </Battle>
    <p>{`Option 1 then `}<strong parentName="p">{`Option 2`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Option 1 here is incredibly important. It decides which battle you do.`}<br parentName="p"></br>{`
`}{`Greenhill battle is practically undoable.`}<br parentName="p"></br>{`
`}{`Waiting in Castle is slower than battle at border.`}</p>
    </blockquote>
    <p>{`Meeting Room `}<strong parentName="p">{`Option 2`}</strong>{` then Option 1`}</p>
    <h3 {...{
      "id": "greenhill-liberation-war-battle"
    }}>{`Greenhill Liberation War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-20"
    }}>{`Turn 1`}</h5>
    <p>{`Riou 1D`}<br parentName="p"></br>{`
`}{`Hauser (R1) 2L`}<br parentName="p"></br>{`
`}{`Teresa (R1) 1U`}<br parentName="p"></br>{`
`}{`Viktor (R1) 2L`}<br parentName="p"></br>{`
`}{`Gilbert (R1) 1D`}</p>
    <h5 {...{
      "id": "turn-2-10"
    }}>{`Turn 2`}</h5>
    <p>{`Riou 1D`}<br parentName="p"></br>{`
`}{`Hauser (R1) 1L1D`}<br parentName="p"></br>{`
`}{`Teresa (R1) 1U`}<br parentName="p"></br>{`
`}{`Viktor (R1) 2L`}<br parentName="p"></br>{`
`}{`Gilbert (R1) 1D`}<br parentName="p"></br>{`
`}{`Flik (R1) 2L`}</p>
    <h5 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h5>
    <p>{`Flik (R2) 2L`}</p>
    <h5 {...{
      "id": "turn-4--on-1"
    }}>{`Turn 4 & on`}</h5>
    <p><em parentName="p">{`If an enemy unit will get in attacking range move away. Shouldn't happen though`}</em><br parentName="p"></br>{`
`}{`End Turn`}</p>
    <h3 {...{
      "id": "greenhill"
    }}>{`Greenhill`}</h3>
    <p><em parentName="p">{`When Shin asks to come along.`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`When Teresa joins `}<strong parentName="p">{`don't change formation.`}</strong></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "party-9"
      }}>{`Party`}</h4>
      <ul>
        <li parentName="ul">{`Rina (RD)`}</li>
        <li parentName="ul">{`Sierra (RU)`}</li>
        <li parentName="ul">{`Camus (X)`}</li>
        <li parentName="ul">{`Luc (U)`}</li>
        <li parentName="ul">{`Kahn (2D)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-7"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Kahn > Sierra`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "soldiers-1"
      }}>{`Soldiers #1`}</h4>
      <ul>
        <li parentName="ul">{`Riou: Exorcism`}</li>
        <li parentName="ul">{`Kahn: Shift`}</li>
        <li parentName="ul">{`Sierra: Take from Bag Shredding Scroll (UX UX Last Slot)`}</li>
      </ul>
    </Battle>
    <h4 {...{
      "id": "soldiers-2"
    }}>{`Soldiers #2`}</h4>
    <ul>
      <li parentName="ul">{`Riou: Exorcism`}</li>
    </ul>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lucia-2-5640hp"
      }}>{`Lucia 2 5640HP`}</h4>
      <ul>
        <li parentName="ul">{`Riou: Lightning Ball Lucia`}</li>
        <li parentName="ul">{`Rina: Blazing Camp Lucia`}</li>
        <li parentName="ul">{`Kahn: Defend`}</li>
        <li parentName="ul">{`Camus: Final Flame / Explosion if no LVL4`}</li>
        <li parentName="ul">{`Luc: Blazing Camp Lucia`}</li>
        <li parentName="ul">{`Sierra: Defend`}</li>
      </ul>
    </Battle>
    <h4 {...{
      "id": "soldiers-3-5"
    }}>{`Soldiers #3-5`}</h4>
    <ul>
      <li parentName="ul">{`Rina: Pale Palace`}</li>
    </ul>
    <p>{`Talk to girl to heal to full.`}</p>
    <h4 {...{
      "id": "soldiers-6"
    }}>{`Soldiers #6`}</h4>
    <ul>
      <li parentName="ul">{`Luc: Dancing Flames`}</li>
    </ul>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bone-dragon-10680hp"
      }}>{`Bone Dragon 10680HP`}</h4>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Exorcism`}</li>
        <li parentName="ul">{`Rina: Pale Palace`}</li>
        <li parentName="ul">{`Kahn: Exorcism`}</li>
        <li parentName="ul">{`Camus: Defend`}</li>
        <li parentName="ul">{`Luc: Shredding`}</li>
        <li parentName="ul">{`Sierra: Shredding Scroll`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Format is EW / Pale Palace. You can EW if Bone Dragon bites Kahn or does Fire Breath`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Exorcism`}</li>
        <li parentName="ul">{`Rina: Empty World / Pale Palace`}</li>
        <li parentName="ul">{`Kahn: Exorcism`}</li>
        <li parentName="ul">{`Camus: Defend / Final Flame`}</li>
        <li parentName="ul">{`Luc: Shredding`}</li>
        <li parentName="ul">{`Sierra: Shredding Scroll`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "castle-15"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Option 2 is faster than Option 3.`}</p>
    </blockquote>
    <p><em parentName="p">{`Shu: "......" > Apple: "Riou, Jowy, ..." "Most of the..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "greenhill-1"
    }}>{`Greenhill`}</h3>
    <Menu mdxType="Menu">
      <p><em parentName="p">{`Take note of how much money you have here.`}</em></p>
      <h4 {...{
        "id": "rune-shop-3"
      }}>{`Rune Shop`}</h4>
      <h5 {...{
        "id": "attach-4"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Blue Gate > Riou Head`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "muse-liberation-war-battle"
    }}>{`Muse Liberation War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-22"
    }}>{`Turn 1`}</h5>
    <p>{`Kiba 2R`}<br parentName="p"></br>{`
`}{`Flik 3R`}</p>
    <h5 {...{
      "id": "turn-2-12"
    }}>{`Turn 2`}</h5>
    <p>{`Kiba 2L`}<br parentName="p"></br>{`
`}{`Flik 3R`}</p>
    <h5 {...{
      "id": "turn-3--4-1"
    }}>{`Turn 3 & 4`}</h5>
    <p>{`Flik runs to Muse`}</p>
    <h3 {...{
      "id": "muse-7"
    }}>{`Muse`}</h3>
    <p>{`Viktor `}<strong parentName="p">{`to convoy`}</strong>{` say `}<strong parentName="p">{`no to change formation.`}</strong></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "party-10"
      }}>{`Party`}</h4>
      <ul>
        <li parentName="ul">{`No Change`}</li>
      </ul>
      <h5 {...{
        "id": "formation-8"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Rina > Sierra`}</li>
        <li parentName="ul">{`Nanami > Sierra`}</li>
      </ul>
      <h4 {...{
        "id": "equipment-10"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "riou-6"
      }}>{`Riou`}</h5>
      <ul>
        <li parentName="ul">{`Medicine > Sierra Shredding (LUX)`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle"> 
      <h4 {...{
        "id": "golden-wolf-4200hp"
      }}>{`Golden Wolf 4200HP`}</h4>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Empty World`}</li>
        <li parentName="ul">{`Nanami: Defend`}</li>
        <li parentName="ul">{`Kahn: Scream`}</li>
        <li parentName="ul">{`Luc: Lightning Ball`}</li>
        <li parentName="ul">{`Rina: Empty World`}</li>
        <li parentName="ul">{`Sierra: Final Bell`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Rina: Empty World`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "castle-16"
    }}>{`Castle`}</h3>
    <p>{`Go to 3rd floor to watch Kiba Shu cutscene`}<br parentName="p"></br>{`
`}{`Talk to Shu Option 1`}</p>
    <p>{`Great Hall just mash > After Kiba cutscenes leave and Blinking Mirror`}<br parentName="p"></br>{`
`}{`Go to Great Hall `}<em parentName="p">{`Shu 1 textbox`}</em>{` `}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "rockaxe-war-battle"
    }}>{`Rockaxe War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-24"
    }}>{`Turn 1`}</h5>
    <p>{`Gilbert 1D`}<br parentName="p"></br>{`
`}{`Luc 1L`}<br parentName="p"></br>{`
`}{`Teresa 1L`}<br parentName="p"></br>{`
`}{`Kasumi 1D`}<br parentName="p"></br>{`
`}{`Ridley 1L`}</p>
    <h5 {...{
      "id": "turns-2--3"
    }}>{`Turns 2 & 3`}</h5>
    <p>{`End Turn`}</p>
    <h3 {...{
      "id": "rockaxe-2"
    }}>{`Rockaxe`}</h3>
    <p>{`Fork (`}<strong parentName="p">{`LEFT`}</strong>{` right)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LADDER`}</strong>{` up)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`UP`}</strong>{` ladder)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LADDER`}</strong>{` right)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LEFT`}</strong>{` up)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}</p>
    <h5 {...{
      "id": "matilda-knight-fights"
    }}>{`Matilda Knight Fights`}</h5>
    <ul>
      <li parentName="ul">{`Pale Palace (Watch damage, want >= 541)`}</li>
      <li parentName="ul">{`Riou Shredding Scroll (unless damage lower than 541, then Pale Palace)`}</li>
    </ul>
    <p><em parentName="p">{`Can save 0.5 seconds by not picking an option to protect Nanami`}</em></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "gorudo-5400hp"
      }}>{`Gorudo 5400HP`}</h4>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Defend (Attack if you used 2nd Pale Palace)`}</li>
        <li parentName="ul">{`Jowy: Hungry Friend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-14"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Lightning Ball`}</li>
        <li parentName="ul">{`Jowy: Piercing One`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Bolt of Wrath`}</li>
        <li parentName="ul">{`Jowy: Piercing One`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Attack`}</li>
        <li parentName="ul">{`Jowy: Piercing One`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "castle-17"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You have ~30 seconds to do whatever here.`}</p>
    </blockquote>
    <p><em parentName="p">{`Move up 3 steps then 1 down (optimal position for cutscene), lines up with Rina`}</em></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "equipment-11"
      }}>{`Equipment`}</h4>
      <h5 {...{
        "id": "riou-7"
      }}>{`Riou`}</h5>
      <ul>
        <li parentName="ul">{`Wing Feather Ornament`}</li>
        <li parentName="ul">{`Master Garb`}</li>
        <li parentName="ul">{`Jizo`}</li>
        <li parentName="ul">{`Power Ring`}</li>
        <li parentName="ul">{`Shredding Scroll`}</li>
      </ul>
      <p><em parentName="p">{`Master Garb, Fire Emblem, and Power Ring should be equipped. The rest doesn't matter.`}</em></p>
      <h4 {...{
        "id": "items-3"
      }}>{`Items`}</h4>
      <p>{`Discard all consumables before Jizos in the menu. Can also discard better non-speed equipment for Eilie optimize.`}</p>
    </Menu>
    <p>{`When you wake up, after fade in you can move instantly so hold left to leave bed`}</p>
    <p>{`Great Hall talk to Shu after delay between textboxes,`}<br parentName="p"></br>{`
`}<em parentName="p">{`"Lord Riou, Give us the order to invade Highland."`}</em>{` `}<strong parentName="p">{`Option 3`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`CM: After exiting war room 1 right`}</em></p>
    <p>{`After waking up leave room and go left to trigger Apple and Shu cutscene.`}<br parentName="p"></br>{`
`}{`Go back to bed, then Great Hall.`}</p>
    <p><em parentName="p">{`Shu 1 textbox`}</em>{` then `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><em parentName="p">{`~30 second break between Riou "We're off!!! To L'Renouille!!!" and next input`}</em></p>
    <h3 {...{
      "id": "shu-war-battle"
    }}>{`Shu War Battle`}</h3>
    <p>{`No control, make sure Viktor has no activatable abilities like Fire Spear`}<br parentName="p"></br>{`
`}{`~1 minute break after Leon "He's not man enough to risk his own life."`}</p>
    <h3 {...{
      "id": "muse-highland-border-1"
    }}>{`Muse-Highland Border`}</h3>
    <p>{`Viktor "Are ya ready yet?" Talk to Apple then `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "lrenouille-war-battle"
    }}>{`L'Renouille War Battle`}</h3>
    <p><em parentName="p">{`Flik Starting position is 1 up 2 right from Riou`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`R1 from Hauser to select Flik (Hauser above Riou)`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`R1 from Riou to select Viktor`}</em></p>
    <h5 {...{
      "id": "turns-1-2"
    }}>{`Turns 1-2`}</h5>
    <p>{`Move Flik & Viktor towards entrance`}</p>
    <h5 {...{
      "id": "turns-3-4"
    }}>{`Turns 3-4`}</h5>
    <p>{`Flik 1 tile away from soldier & Fire Spear x2`}<br parentName="p"></br>{`
`}{`Keep moving Viktor towards entrance`}</p>
    <h5 {...{
      "id": "turn-5--on"
    }}>{`Turn 5 & on`}</h5>
    <p>{`5th turn, if soldier still not dead Viktor attack & Flik attack until dead`}<br parentName="p"></br>{`
`}{`Move into L'Renouille as soon as he dies`}</p>
    <h3 {...{
      "id": "lrenouille"
    }}>{`L'Renouille`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-11"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Eilie (U)`}</li>
        <li parentName="ul">{`Rina (U)`}</li>
        <li parentName="ul">{`Flik (X)`}</li>
        <li parentName="ul">{`Camus (R3DX)`}</li>
        <li parentName="ul">{`Luc (R3DX)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-9"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Flik > Luc`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lucia-7800hp"
      }}>{`Lucia 7800HP`}</h4>
      <h5 {...{
        "id": "turn-1-26"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Lightning Ball Lucia`}</li>
        <li parentName="ul">{`Rina: Blazing Camp`}</li>
        <li parentName="ul">{`Eilie: Defend`}</li>
        <li parentName="ul">{`Flik: Blazing Camp`}</li>
        <li parentName="ul">{`Camus: Final Flame`}</li>
        <li parentName="ul">{`Luc: Blazing Camp`}</li>
      </ul>
    </Battle>
    <p>{`First 2 Soldier Battles: Riou Pale Palace`}</p>
    <h4 {...{
      "id": "han-duel-600hp"
    }}>{`Han Duel 600HP`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Han Action`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Dialogue`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`And now it's my turn.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Hohoho... You taught him well, Genkaku my friend...`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`I can't let you past here, son.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`I should have avoided that cheap little shot...`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Let's bury our past here, boy!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Now feel my deadly sword.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Unf... You like to take risks, eh.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Attack`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Very good, boy.`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Watch and learn, boy. Here's how to wield a sword!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`Well struck... It seems I should be more careful...`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Special`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`You think my sword has lost its bite?!!!`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Defend`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`You think you can beat me, boy?`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Can you take this?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Foolish boy!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Genkaku... You raised a good son...`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`I may be old, but I haven't lost my sword arm.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Let me see your power, son of Genkaku!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Let's see if you can withstand another of my blows!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The leader of the - Army is cautious,  I see...`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Try that again, boy.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Unf... Your father would have been proud to see you today...`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Watch closely, boy!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`What will you do now, boy?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`What's wrong? Want to try again?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes, but can you defend against my sword?!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You can't defend yourself forever.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You can't win like that, boy.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You'll have to do better than that.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You're a tough one...`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`You've got spirit...`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Next 3 Soldier Battles: Rina Pale Palace`}<br parentName="p"></br>{`
`}{`Menu after Rina used up her LVL3 MP`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "equipment-12"
      }}>{`Equipment`}</h4>
      <ul>
        <li parentName="ul">{`Rina: Remove Speed Gear, equip Jizos`}</li>
        <li parentName="ul">{`Eilie: Best Equip`}</li>
      </ul>
    </Menu>
    <p>{`Last 3 Soldier Battles: Luc Shredding`}<br parentName="p"></br>{`
`}{`Heal via Save Crystal before Seed and Culgan`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "seed-5040hp--culgan-4560hp"
      }}>{`Seed 5040HP & Culgan 4560HP`}</h4>
      <h5 {...{
        "id": "turn-1-27"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Empty World`}</li>
        <li parentName="ul">{`Rina: Empty World`}</li>
        <li parentName="ul">{`Eilie: Lightning Ball Seed`}</li>
        <li parentName="ul">{`Luc: Blazing Camp Seed`}</li>
        <li parentName="ul">{`Camus: Final Flame`}</li>
        <li parentName="ul">{`Flik: Blazing Camp Culgan`}</li>
      </ul>
    </Battle>
    <p><strong parentName="p">{`Note your 2 fastest Lightning users. Riou must be 3rd fastest or slower.`}</strong><br parentName="p"></br>{`
`}{`Should be Luc + Flik or Eilie`}</p>
    <p>{`Heal via Save Crystal before Beast Rune`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "beast-rune"
      }}>{`Beast Rune`}</h4>
      <h5 {...{
        "id": "turn-1-28"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Pale Palace`}</li>
        <li parentName="ul">{`2 Fastest: Blazing Camp / Lightning Ball Rune`}</li>
        <li parentName="ul">{`2 Slower: Blazing Camp / Lightning Ball Right Leg`}</li>
        <li parentName="ul">{`Camus: Final Flame`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-15"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Riou: Pale Palace / Empty World`}</li>
        <li parentName="ul">{`Rina: Pale Palace`}</li>
        <li parentName="ul">{`Eilie: Bolt of Wrath Right Head`}</li>
        <li parentName="ul">{`Flik: Bolt of Wrath Right Head`}</li>
        <li parentName="ul">{`Camus: Explosion`}</li>
        <li parentName="ul">{`Luc: Shredding`}</li>
      </ul>
      <p>{`Repeat till dead.`}</p>
    </Battle>
    <h3 {...{
      "id": "castle-18"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall`}<br parentName="p"></br>{`
`}{`Just mash text, after selecting Option 1 2 more textboxes then split!`}</p>
    <h3 {...{
      "id": "fin"
    }}>{`Fin`}</h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      